import { Box, ButtonBase } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import InsertDriveFileOutlined from '@material-ui/icons/InsertDriveFileOutlined';
import clsx from 'clsx';
import React, { FC } from 'react';
import { Picture } from 'Models/Picture/@types';
import helpers from 'Utils/helpers';
import { getFileName } from 'Utils/fileHelpers';

export interface FileAttachmentProps {
    picture: Picture;
    className?: string;
}

const FileAttachment: FC<FileAttachmentProps> = ({ picture, className }) => {
    const classes = useStyles();
    const url = helpers.getPictureUrl(picture);
    const fileName = getFileName(picture);

    const handleClick = () => {
        if (url) window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <Box component={ButtonBase} className={clsx(classes.chip, className)} onClick={handleClick}>
            <InsertDriveFileOutlined className={classes.icon} />
            <Box component="span" className={classes.fileName}>
                {fileName}
            </Box>
        </Box>
    );
};

const useStyles = makeStyles<Theme>((theme) =>
    createStyles({
        chip: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: theme.spacing(0.75),
            padding: theme.spacing(0.5, 1),
            borderRadius: 4,
            border: `1px solid ${theme.palette.grey[300]}`,
            backgroundColor: theme.palette.grey[50],
            cursor: 'pointer',
            transition: 'background-color 0.2s, border-color 0.2s',
            '&:hover': {
                backgroundColor: theme.palette.grey[100],
                borderColor: theme.palette.grey[400],
            },
        },
        icon: {
            fontSize: theme.spacing(2),
            color: theme.palette.grey[600],
        },
        fileName: {
            fontSize: theme.typography.body2.fontSize,
            color: theme.palette.text.primary,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: 180,
        },
    }),
);

export default FileAttachment;
